import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { share } from "../../utils/Helper";

const TextCard = ({ text, handleShareData , sharetext}) => {
  return (
    <>
      <div className="textcard_pad">
        <div className="textcard_bg">
          <div className="quote_flex">
            <img src="/assets/images/quote.svg" className="quote_img" alt="" />

            <button
              className="quote_share"
              onClick={() => {
                share(
                  text.id,
                  sharetext,
                  "youtube",
                  `https://www.narendramodi.in/parikshapecharcha2025/${text.episode_id}/text/${text.id}`
                );
                handleShareData(
                  `https://www.narendramodi.in/parikshapecharcha2025/${text.episode_id}/text/${text.id}`,
                  sharetext,
                  sharetext,
                  "youtube"
                );
              }}
            >
              <img src="/assets/images/shareorange.svg" alt="" /> Share
            </button>
          </div>

          <div className="quote_des">
            <div className="quote_scroll_height">
              <PerfectScrollbar options={{ suppressScrollX: true }}>
                <p>{text?.description}</p>
              </PerfectScrollbar>
            </div>
            <h3>{text?.title}</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default TextCard;
